export default __webpack_public_path__ + "static/media/pause_map_icon.2560ba9a.svg";